import { Stack, Typography } from "@altimateai/lego";
import { CreateReferralCodeForm } from "./components/CreateReferralCodeForm";
import { ReferralCodesTable } from "./components/ReferralCodesTable";

export const ReferralAdmin = () => (
  <div className="al-p-6 al-max-w-6xl al-mx-auto al-space-y-6">
    <Stack direction="row" justify="between" align="center">
      <div>
        <Typography variant="h1" weight="semibold">
          Referral codes
        </Typography>
        <Typography variant="body" className="al-text-gray-600 al-mt-1">
          Create and manage freemium signup referral codes.
        </Typography>
      </div>
      <CreateReferralCodeForm />
    </Stack>

    <ReferralCodesTable />
  </div>
);
